var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddScript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 2,
    fill: "#727272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90918 8.96973L6.88281 15H5.46191L8.11816 7.89062H9.02637L8.90918 8.96973ZM10.6035 15L8.56738 8.96973L8.44531 7.89062H9.3584L12.0293 15H10.6035ZM10.5107 12.3584V13.418H6.69727V12.3584H10.5107ZM14.8857 15H13.3525L13.3623 13.9453H14.8857C15.2992 13.9453 15.6458 13.8542 15.9258 13.6719C16.2057 13.4863 16.4173 13.221 16.5605 12.876C16.7038 12.5277 16.7754 12.111 16.7754 11.626V11.2598C16.7754 10.8854 16.7347 10.555 16.6533 10.2686C16.5719 9.9821 16.4515 9.74121 16.292 9.5459C16.1357 9.35059 15.9421 9.20247 15.7109 9.10156C15.4798 9.00065 15.2145 8.9502 14.915 8.9502H13.3232V7.89062H14.915C15.3903 7.89062 15.8232 7.97038 16.2139 8.12988C16.6077 8.28939 16.9479 8.51888 17.2344 8.81836C17.5241 9.11458 17.7454 9.4694 17.8984 9.88281C18.0547 10.2962 18.1328 10.7585 18.1328 11.2695V11.626C18.1328 12.1338 18.0547 12.596 17.8984 13.0127C17.7454 13.4261 17.5241 13.7809 17.2344 14.0771C16.9479 14.3734 16.6061 14.6012 16.209 14.7607C15.8118 14.9202 15.3708 15 14.8857 15ZM14.1045 7.89062V15H12.7617V7.89062H14.1045Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddScript);
export default __webpack_public_path__ + "static/media/add_script.fd3be644f9d40d5781de9d57d9b0be88.svg";
export { ForwardRef as ReactComponent };